import React from "react";
import T from "prop-types";
import string from "LIB/strings";
import { Icon } from "MODULES/shared/components";
import { NoteTooltip } from "MODULES/shared/components/NoteTooltip";
import Detail from "./Detail";

export default function SpecialInstructions({ note, placement = "right" }) {
  const display = !string(note).empty() && (
    <span className="text-success">
      <Icon name="check" />
      Yes <NoteTooltip note={note} placement={placement} />
    </span>
  );

  return <Detail label="Special Instructions" value={display} />;
}

SpecialInstructions.propTypes = {
  note: T.string,
  placement: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DetailTable/SpecialInstructions.jsx